export default <TInput, TOptions, TResult>(
    wrapped: (a: TInput, b?: TOptions) => TResult,
    amend: (c?: TOptions | undefined) => TOptions | undefined
) =>
    (a: TInput, b?: TOptions): TResult =>
        wrapped(a, amend(b));
